/* =======================================================================
   PANDISWELT LIEFERTERMIN

   Custom Element: <pandiswelt-delivery>

   Berechnet im Browser den voraussichtlichen Zustelltag und zeigt bis zum
   Annahmeschluss einen Countdown. Rechnet in der Zeitzone Europe/Berlin,
   unabhaengig davon, wo der Besucher sitzt.

   Regeln:
     - Annahmeschluss werktags um 14:00 Uhr
     - Mo-Do vor 14 Uhr  -> Versand am naechsten Tag
     - Fr vor 14 Uhr     -> Versand am Samstag
     - Fr ab 14 Uhr      -> Versand am Montag
     - Sa / So           -> Versand am Montag + Sicherheitspuffer
     - Versandtage sind Mo-Sa, Feiertage werden uebersprungen
     - Zustellung 2 Werktage nach Versand, in Spitzenzeiten 3

   Keine Abhaengigkeiten, kein Netzwerkzugriff.
   ======================================================================= */

(function () {
  'use strict';

  /* ---------- Einstellungen ---------- */

  /* Annahmeschluss (Stunde in Berliner Zeit) */
  var CUTOFF_STUNDE = 14;

  /* Zustelltage nach dem Versandtag */
  var ZUSTELLTAGE_NORMAL = 2;
  var ZUSTELLTAGE_SPITZE = 3;

  /* Zusaetzlicher Puffertag fuer Bestellungen am Wochenende */
  var WOCHENENDE_PUFFER_TAGE = 1;

  /* Gilt eine Bestellung Freitag nach Annahmeschluss als Wochenende?
     false = Versand Montag, true = Versand Montag + Puffer */
  var FREITAG_NACH_CUTOFF_WIE_WOCHENENDE = false;

  /* Spitzenzeiten als [Monat, TagVon, TagBis] — Monat 1-basiert */
  var SPITZENZEITEN = [
    [11, 20, 30], /* Black-Friday-Woche */
    [12, 1, 23]   /* Weihnachtsgeschaeft */
  ];

  var WOCHENTAGE = [
    'Sonntag', 'Montag', 'Dienstag', 'Mittwoch',
    'Donnerstag', 'Freitag', 'Samstag'
  ];

  /* ---------- Zeit in Europe/Berlin ---------- */

  var berlinFormatter = null;

  function berlinJetzt() {
    if (!berlinFormatter) {
      berlinFormatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    }

    var teile = berlinFormatter.formatToParts(new Date());
    var werte = {};
    for (var i = 0; i < teile.length; i++) {
      if (teile[i].type !== 'literal') {
        werte[teile[i].type] = parseInt(teile[i].value, 10);
      }
    }

    /* hour kann bei Mitternacht als 24 geliefert werden */
    if (werte.hour === 24) werte.hour = 0;

    return werte;
  }

  /* ---------- Datums-Helfer (auf UTC-Basis, damit keine
       Sommerzeit-Spruenge in die Rechnung geraten) ---------- */

  function tagAlsZahl(jahr, monat, tag) {
    return Date.UTC(jahr, monat - 1, tag);
  }

  function plusTage(zeitstempel, tage) {
    return zeitstempel + tage * 86400000;
  }

  function schluessel(zeitstempel) {
    var d = new Date(zeitstempel);
    var m = d.getUTCMonth() + 1;
    var t = d.getUTCDate();
    return d.getUTCFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (t < 10 ? '0' + t : t);
  }

  function wochentag(zeitstempel) {
    return new Date(zeitstempel).getUTCDay(); /* 0 = Sonntag */
  }

  /* ---------- Feiertage Niedersachsen ---------- */

  var feiertagCache = {};

  /* Ostersonntag nach der Gauss-Formel (Meeus/Jones/Butcher) */
  function ostersonntag(jahr) {
    var a = jahr % 19;
    var b = Math.floor(jahr / 100);
    var c = jahr % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31);
    var tag = ((h + l - 7 * m + 114) % 31) + 1;
    return tagAlsZahl(jahr, monat, tag);
  }

  function feiertage(jahr) {
    if (feiertagCache[jahr]) return feiertagCache[jahr];

    var ostern = ostersonntag(jahr);
    var liste = [
      tagAlsZahl(jahr, 1, 1),        /* Neujahr */
      plusTage(ostern, -2),          /* Karfreitag */
      plusTage(ostern, 1),           /* Ostermontag */
      tagAlsZahl(jahr, 5, 1),        /* Tag der Arbeit */
      plusTage(ostern, 39),          /* Christi Himmelfahrt */
      plusTage(ostern, 50),          /* Pfingstmontag */
      tagAlsZahl(jahr, 10, 3),       /* Tag der Deutschen Einheit */
      tagAlsZahl(jahr, 10, 31),      /* Reformationstag */
      tagAlsZahl(jahr, 12, 24),      /* Heiligabend (kein Versand) */
      tagAlsZahl(jahr, 12, 25),      /* 1. Weihnachtstag */
      tagAlsZahl(jahr, 12, 26),      /* 2. Weihnachtstag */
      tagAlsZahl(jahr, 12, 31)       /* Silvester (kein Versand) */
    ];

    var menge = {};
    for (var i = 0; i < liste.length; i++) {
      menge[schluessel(liste[i])] = true;
    }

    feiertagCache[jahr] = menge;
    return menge;
  }

  function istFeiertag(zeitstempel) {
    var jahr = new Date(zeitstempel).getUTCFullYear();
    return feiertage(jahr)[schluessel(zeitstempel)] === true;
  }

  /* Versand und Zustellung laufen Mo-Sa */
  function istLiefertag(zeitstempel) {
    var tag = wochentag(zeitstempel);
    if (tag === 0) return false;
    return !istFeiertag(zeitstempel);
  }

  function naechsterLiefertag(zeitstempel) {
    var d = zeitstempel;
    var schutz = 0;
    while (!istLiefertag(d) && schutz < 30) {
      d = plusTage(d, 1);
      schutz++;
    }
    return d;
  }

  function liefertageAddieren(zeitstempel, anzahl) {
    var d = zeitstempel;
    var offen = anzahl;
    var schutz = 0;
    while (offen > 0 && schutz < 60) {
      d = plusTage(d, 1);
      if (istLiefertag(d)) offen--;
      schutz++;
    }
    return d;
  }

  function istSpitzenzeit(monat, tag) {
    for (var i = 0; i < SPITZENZEITEN.length; i++) {
      var z = SPITZENZEITEN[i];
      if (monat === z[0] && tag >= z[1] && tag <= z[2]) return true;
    }
    return false;
  }

  /* ---------- Berechnung ---------- */

  function berechne() {
    var jetzt = berlinJetzt();
    var heute = tagAlsZahl(jetzt.year, jetzt.month, jetzt.day);
    var tag = wochentag(heute);
    var vorCutoff = jetzt.hour < CUTOFF_STUNDE;

    /* Heute noch bestellbar? Nur Mo-Fr vor 14 Uhr und nicht an Feiertagen */
    var countdownAktiv = tag >= 1 && tag <= 5 && vorCutoff && !istFeiertag(heute);

    /* Versandtag bestimmen */
    var versand;
    var istWochenendbestellung = false;

    if (tag === 6 || tag === 0) {
      /* Samstag oder Sonntag */
      istWochenendbestellung = true;
      versand = naechsterLiefertag(plusTage(heute, tag === 6 ? 2 : 1));
    } else if (vorCutoff && !istFeiertag(heute)) {
      /* Werktag vor Annahmeschluss */
      versand = naechsterLiefertag(plusTage(heute, 1));
    } else {
      /* Werktag nach Annahmeschluss oder Feiertag */
      if (tag === 5 && FREITAG_NACH_CUTOFF_WIE_WOCHENENDE) {
        istWochenendbestellung = true;
      }
      versand = naechsterLiefertag(plusTage(heute, 1));
      /* Nach Cutoff bleibt der Folgetag nur Abholtag, wenn er ein Liefertag
         ist — sonst rutscht er ohnehin weiter. Zusaetzlich einen Tag, da die
         Sendung erst am uebernaechsten Tag in den Versand geht. */
      versand = naechsterLiefertag(plusTage(versand, 1));
    }

    if (istWochenendbestellung && WOCHENENDE_PUFFER_TAGE > 0) {
      versand = liefertageAddieren(versand, WOCHENENDE_PUFFER_TAGE);
    }

    /* Zustellung */
    var zustelltage = istSpitzenzeit(jetzt.month, jetzt.day)
      ? ZUSTELLTAGE_SPITZE
      : ZUSTELLTAGE_NORMAL;

    var ankunft = liefertageAddieren(versand, zustelltage);

    /* Restzeit bis zum Annahmeschluss */
    var restSekunden = 0;
    if (countdownAktiv) {
      var vergangen = jetzt.hour * 3600 + jetzt.minute * 60 + jetzt.second;
      restSekunden = CUTOFF_STUNDE * 3600 - vergangen;
      if (restSekunden < 0) restSekunden = 0;
    }

    return {
      countdownAktiv: countdownAktiv && restSekunden > 0,
      restSekunden: restSekunden,
      ankunft: ankunft
    };
  }

  /* ---------- Ausgabe ---------- */

  function datumText(zeitstempel) {
    var d = new Date(zeitstempel);
    var t = d.getUTCDate();
    var m = d.getUTCMonth() + 1;
    return WOCHENTAGE[d.getUTCDay()] + ', '
      + (t < 10 ? '0' + t : t) + '.'
      + (m < 10 ? '0' + m : m) + '.';
  }

  function restzeitText(sekunden) {
    var stunden = Math.floor(sekunden / 3600);
    var minuten = Math.floor((sekunden % 3600) / 60);

    if (stunden > 0) {
      return stunden + ' Std ' + minuten + ' Min';
    }
    if (minuten > 0) {
      return minuten + ' Min';
    }
    return 'weniger als 1 Min';
  }

  /* ---------- Custom Element ---------- */

  class PandisweltDelivery extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.zeichnen();

      /* Nur ticken, solange ein Countdown laeuft */
      var ergebnis = berechne();
      if (ergebnis.countdownAktiv) {
        this.timer = setInterval(this.zeichnen.bind(this), 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    zeichnen() {
      var ergebnis;
      try {
        ergebnis = berechne();
      } catch (e) {
        /* Bei einem Fehler bleibt der statische Fallback-Text stehen */
        return;
      }

      var datum = '<span class="pandiswelt-stock__date">'
        + datumText(ergebnis.ankunft) + '</span>';

      if (ergebnis.countdownAktiv) {
        this.innerHTML =
          'Bestell in den nächsten <span class="pandiswelt-stock__countdown">'
          + restzeitText(ergebnis.restSekunden)
          + '</span> – voraussichtlich bis ' + datum + ' bei dir';
      } else {
        this.innerHTML = 'Voraussichtlich bis ' + datum + ' bei dir';

        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  }

  if (!customElements.get('pandiswelt-delivery')) {
    customElements.define('pandiswelt-delivery', PandisweltDelivery);
  }
})();
